import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { BASE_URL } from '../../api/baseURL';
import { axiosBaseQuery } from '../axiosBaseQuery';
import { PaginatedResponse, Response } from '../genericInterface';
import { IHotel, IRoomType } from './interface';

export const hotelApi = createApi({
  reducerPath: 'hotelApi',
  baseQuery: axiosBaseQuery({
    baseUrl: BASE_URL
  }),
  tagTypes: ['hotels'],
  endpoints: (builder) => ({
    addHotel: builder.mutation<Response<IHotel>, FormData>({
      query: (payload) => ({
        url: '/hotel/add',
        method: 'POST',
        body: payload
      }),
      invalidatesTags: ['hotels']
    }),
    deleteHotel: builder.mutation<Response<null>, string>({
      query: (payload) => ({
        url: `/hotel/delete/${payload}`,
        method: 'DELETE'
      }),
      invalidatesTags: ['hotels']
    }),
    deleteRoomType: builder.mutation<Response<null>, string>({
      query: (payload) => ({
        url: `/hotel-details/delete/${payload}`,
        method: 'DELETE'
      }),
      invalidatesTags: ['hotels']
    }),
    getAllHotel: builder.query<PaginatedResponse<IHotel>, string>({
      query: (query) => ({
        url: `/hotel/get-all?${query}`,
        method: 'GET'
      }),
      providesTags: ['hotels']
    }),
    addHotelDetails: builder.mutation<
      Response<IRoomType>,
      { body: FormData; id: string }
    >({
      query: (payload) => ({
        url: '/hotel-details/add',
        method: 'POST',
        body: payload.body
      }),
      invalidatesTags: ['hotels']
    }),
    getHotelById: builder.query<Response<IHotel>, string>({
      query: (id) => ({
        url: `/hotel/get-one/${id}`,
        method: 'GET'
      }),
      providesTags: (_result, _err, arg) => [{ type: 'hotels', id: arg }]
    }),
    editHotel: builder.mutation<Response<IHotel>, FormData>({
      query: (payload) => ({
        url: `/hotel/edit`,
        method: 'PATCH',
        body: payload
      })
    }),
    changeStatus: builder.mutation<Response<IRoomType>, string>({
      query: (id) => ({
        url: `/hotel-details/room-availability/${id}`,
        method: 'PATCH'
      }),
      invalidatesTags: ['hotels']
    })
  })
});

export const {
  useAddHotelMutation,
  useGetAllHotelQuery,
  useGetHotelByIdQuery,
  useAddHotelDetailsMutation,
  useDeleteHotelMutation,
  useEditHotelMutation,
  useDeleteRoomTypeMutation,
  useChangeStatusMutation
} = hotelApi;
